import App from "../../App";
import {NOTIFY, UPDATE_BASE} from "../Actions/base";

const savedState = App.storage.get('redux')?.base || {};

const initialState = {
    printer_port: null,
    printerList: [],
    printerConfigurations: {},
    hemoRequestFormPrintView: false,
    hemoReadyProductPrintOnPrepare: true,
    hemoReadyProductPrintLabelOnDeliver: true,
    hemoReadyProductPrintFormOnDeliver: true,
    normRequestFormPrintOnSubmit: true,
    orgRequestFormPrintOnSubmit: true,
    bloodGroups: [],
    bloodGroupsById: [],
    productTypes: [],
    productTypesById: [],
    allSections: [],
    doctors: [],
    hospitalSections: [],
    allHospitals: [],
    hospitalReturnReasons: [],
    sectionReturnReasons: [],
    destroyedReasons: [],
    surgeryTypes: [],
    genders: [],
    provinceCities: [],
    patientDiagnostics: [],
    roles: [],
    ...savedState,
    notifies: {},
    onlineSocket: false
};

const reducer = (state = initialState, action) => {
    let newState = {...state};

    switch (action.type) {
        case UPDATE_BASE:
            delete action.type;
            newState = {
                ...state,
                ...action
            };
            break;
        case NOTIFY:
            newState.notifies = {};
            for (const item of action.notifications)
                newState.notifies[item.key] = item.count;
            newState.notifies.all = Object.entries(newState.notifies).reduce((sum, item) => sum + item[1], 0);
            break;
        default:
            return newState;
    }

    App.storage.set('redux', {
        ...App.storage.get('redux', {}),
        base: newState
    });

    return newState;
};

export default reducer